/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { LimitsInfoDTO } from './LimitsInfoDTO';

export type TierDetailDTO = {
    limitsInfo?: LimitsInfoDTO;
    tierDescription?: string;
    tierName?: TierDetailDTO.tierName;
    tierNumber?: number;
    tierSubTitle?: string;
};

export namespace TierDetailDTO {

    export enum tierName {
        BRONZE = 'BRONZE',
        SILVER = 'SILVER',
        GOLD = 'GOLD',
        PLATINUM = 'PLATINUM',
    }


}

